import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="relative py-10 md:py-14 bg-black overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-t from-[#004048]/25 to-transparent" />
      
      <div className="relative z-10 max-w-[1200px] mx-auto px-6 lg:px-12 text-center">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-3 heading">Stop Waiting. <span className="text-[#59d862]">Start Growing.</span></h2>
        <p className="text-base text-white/55 max-w-lg mx-auto mb-6">Join 1,000+ agents who have transformed their cash flow.</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/get-paid" className="btn-primary text-base px-6 py-3 flex items-center gap-2 group">
            Get Paid Now <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link to="/apply" className="btn-secondary text-base px-6 py-3">Apply to Join</Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
